import {
    Container,
    ContainerGutter,
    ContainerPadding,
    CTA,
    Text,
    TextTag,
    TokenTextAppearance,
} from '@volkswagen-onehub/components-core'
import styled from 'styled-components'
import {Close} from '@volkswagen-onehub/icons-core'
import React from 'react'
import {useTranslation} from 'react-i18next'

const HeaderContainer = styled.header`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: ${(props) => props.theme.size.static300};
`

const CTAWrapper = styled.div`
    display: flex;
    justify-content: center;
    padding: ${(props) => props.theme.size.static300};

    button {
        margin: 0 ${(props) => props.theme.size.static200}
            ${(props) => props.theme.size.static300};
    }
`

const CloseButton = styled.button`
    background: none;
    border: none;
    cursor: pointer;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    right: ${(props) => props.theme.size.static300};
    top: ${(props) => props.theme.size.static300};
    width: ${(props) => props.theme.size.static500};
    height: ${(props) => props.theme.size.static500};
    color: ${(props) => props.theme.colors.content.active};

    &:hover {
        color: ${(props) => props.theme.colors.content.hover};
    }
`

export interface PurchaseLayerContentProps {
    onCloseClick: () => void
    onConfirmClick: () => void
    promotionTitle: string
    purchaseUrl: string
}

export const PurchaseLayerContent = (props: PurchaseLayerContentProps) => {
    const {t} = useTranslation('fa-listini')

    return (
        <Container
            gutter={ContainerGutter.static300}
            padding={ContainerPadding.grid001}
            wrap="always"
        >
            <HeaderContainer>
                <Text
                    tag={TextTag.h3}
                    appearance={TokenTextAppearance.headline400}
                    bold
                >
                    {t('purchaseLayer.title')}
                </Text>
                <CloseButton
                    onClick={props.onCloseClick}
                    aria-label={t('purchaseLayer.closeLabel')}
                    tabIndex={0}
                >
                    <Close variant="default" aria-hidden />
                </CloseButton>
            </HeaderContainer>
            <Text tag={TextTag.p} appearance={TokenTextAppearance.copy200}>
                {t('purchaseLayer.disclaimer')}
            </Text>
            <CTAWrapper>
                <CTA
                    tag="a"
                    emphasis="primary"
                    href={props.purchaseUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() => {
                        props.onConfirmClick()
                    }}
                >
                    {t('purchaseLayer.ctaLabel')}
                </CTA>
            </CTAWrapper>
        </Container>
    )
}
